/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayResultsBar.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayResultsBar.
 * @public
 */

goog.module('ClayResultsBar.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
goog.require('goog.string');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias2 = Soy.getTemplate('ClayButton.incrementaldom', 'render');

var $templateAlias3 = Soy.getTemplate('ClayFilterLabel.incrementaldom', 'render');

var $templateAlias1 = Soy.getTemplate('ClayLink.incrementaldom', 'render');


/**
 * @param {{
 *  filterLabels: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  totalItems: number,
 *  _handleClearResultsClick: (*|null|undefined),
 *  _handleFilterLabelCloseClicked: (*|null|undefined),
 *  clearResultsURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  searchValue: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var filterLabels = soy.asserts.assertType(goog.isArray(opt_data.filterLabels), 'filterLabels', opt_data.filterLabels, '!Array<?>');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {number} */
  var totalItems = soy.asserts.assertType(goog.isNumber(opt_data.totalItems), 'totalItems', opt_data.totalItems, 'number');
  /** @type {*|null|undefined} */
  var _handleClearResultsClick = opt_data._handleClearResultsClick;
  /** @type {*|null|undefined} */
  var _handleFilterLabelCloseClicked = opt_data._handleFilterLabelCloseClicked;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var clearResultsURL = soy.asserts.assertType(opt_data.clearResultsURL == null || (goog.isString(opt_data.clearResultsURL) || opt_data.clearResultsURL instanceof goog.soy.data.SanitizedContent), 'clearResultsURL', opt_data.clearResultsURL, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var searchValue = soy.asserts.assertType(opt_data.searchValue == null || (goog.isString(opt_data.searchValue) || opt_data.searchValue instanceof goog.soy.data.SanitizedContent), 'searchValue', opt_data.searchValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('nav');
      incrementalDom.attr('class', 'tbar tbar-inline-xs-down subnav-tbar subnav-tbar-primary');
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'container-fluid container-fluid-max-xl');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('ul');
          incrementalDom.attr('class', 'tbar-nav tbar-nav-wrap');
      incrementalDom.elementOpenEnd();
        var hasFilterLabels__soy1280 = (filterLabels.length) > 0;
        $results({expand: !hasFilterLabels__soy1280, searchValue: searchValue, totalItems: totalItems}, null, opt_ijData);
        if (hasFilterLabels__soy1280) {
          $filterLabels(opt_data, null, opt_ijData);
        }
        $clearResults(opt_data, null, opt_ijData);
      incrementalDom.elementClose('ul');
    incrementalDom.elementClose('div');
  incrementalDom.elementClose('nav');
}
exports.render = $render;
/**
 * @typedef {{
 *  filterLabels: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  totalItems: number,
 *  _handleClearResultsClick: (*|null|undefined),
 *  _handleFilterLabelCloseClicked: (*|null|undefined),
 *  clearResultsURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  searchValue: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayResultsBar.render';
}


/**
 * @param {{
 *  _handleClearResultsClick: (*|null|undefined),
 *  clearResultsURL: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $clearResults(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  opt_data = opt_data || {};
  /** @type {*|null|undefined} */
  var _handleClearResultsClick = opt_data._handleClearResultsClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var clearResultsURL = soy.asserts.assertType(opt_data.clearResultsURL == null || (goog.isString(opt_data.clearResultsURL) || opt_data.clearResultsURL instanceof goog.soy.data.SanitizedContent), 'clearResultsURL', opt_data.clearResultsURL, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('li');
      incrementalDom.attr('class', 'tbar-item');
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'tbar-section');
    incrementalDom.elementOpenEnd();
      if (clearResultsURL) {
        var msg_4430__soy4431 = '';
        /** @desc Label for clear results link */
        var MSG_EXTERNAL_517843663917688276 = goog.getMsg('clear');
        msg_4430__soy4431 += MSG_EXTERNAL_517843663917688276;
        $templateAlias1({elementClasses: 'component-link tbar-link', events: {click: _handleClearResultsClick}, href: clearResultsURL, label: '' + msg_4430__soy4431, ref: 'clearSearch'}, null, opt_ijData);
      } else {
        var msg_4433__soy4434 = '';
        /** @desc Label for clear results button */
        var MSG_EXTERNAL_517843663917688276$$1 = goog.getMsg('clear');
        msg_4433__soy4434 += MSG_EXTERNAL_517843663917688276$$1;
        $templateAlias2({elementClasses: 'component-link tbar-link', events: {click: _handleClearResultsClick}, label: '' + msg_4433__soy4434, ref: 'clearSearch', style: 'unstyled'}, null, opt_ijData);
      }
    incrementalDom.elementClose('div');
  incrementalDom.elementClose('li');
}
exports.clearResults = $clearResults;
/**
 * @typedef {{
 *  _handleClearResultsClick: (*|null|undefined),
 *  clearResultsURL: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$clearResults.Params;
if (goog.DEBUG) {
  $clearResults.soyTemplateName = 'ClayResultsBar.clearResults';
}


/**
 * @param {{
 *  filterLabels: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleFilterLabelCloseClicked: (*|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $filterLabels(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  /** @type {!Array<?>} */
  var filterLabels = soy.asserts.assertType(goog.isArray(opt_data.filterLabels), 'filterLabels', opt_data.filterLabels, '!Array<?>');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleFilterLabelCloseClicked = opt_data._handleFilterLabelCloseClicked;
  var filterLabel1361List = filterLabels;
  var filterLabel1361ListLen = filterLabel1361List.length;
  for (var filterLabel1361Index = 0; filterLabel1361Index < filterLabel1361ListLen; filterLabel1361Index++) {
      var filterLabel1361Data = filterLabel1361List[filterLabel1361Index];
      var clayFilterLabelClasses__soy1343 = '';
      clayFilterLabelClasses__soy1343 += 'tbar-item';
      clayFilterLabelClasses__soy1343 += filterLabel1361Index == filterLabel1361ListLen - 1 ? ' tbar-item-expand' : '';
      incrementalDom.elementOpenStart('li');
          incrementalDom.attr('class', clayFilterLabelClasses__soy1343);
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('div');
            incrementalDom.attr('class', 'tbar-section');
        incrementalDom.elementOpenEnd();
          $templateAlias3({closeable: ($$temp = filterLabel1361Data.closeable) == null ? true : $$temp, data: {labelId: filterLabel1361Index}, events: {filterLabelCloseClicked: _handleFilterLabelCloseClicked}, filterData: filterLabel1361Data.data, label: filterLabel1361Data.label, ref: 'label' + filterLabel1361Index, spritemap: spritemap}, null, opt_ijData);
        incrementalDom.elementClose('div');
      incrementalDom.elementClose('li');
    }
}
exports.filterLabels = $filterLabels;
/**
 * @typedef {{
 *  filterLabels: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleFilterLabelCloseClicked: (*|null|undefined)
 * }}
 */
$filterLabels.Params;
if (goog.DEBUG) {
  $filterLabels.soyTemplateName = 'ClayResultsBar.filterLabels';
}


/**
 * @param {{
 *  totalItems: number,
 *  expand: (boolean|null|undefined),
 *  searchValue: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $results(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {number} */
  var totalItems = soy.asserts.assertType(goog.isNumber(opt_data.totalItems), 'totalItems', opt_data.totalItems, 'number');
  /** @type {boolean|null|undefined} */
  var expand = soy.asserts.assertType(opt_data.expand == null || (goog.isBoolean(opt_data.expand) || opt_data.expand === 1 || opt_data.expand === 0), 'expand', opt_data.expand, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var searchValue = soy.asserts.assertType(opt_data.searchValue == null || (goog.isString(opt_data.searchValue) || opt_data.searchValue instanceof goog.soy.data.SanitizedContent), 'searchValue', opt_data.searchValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var elementClasses__soy1369 = '';
  elementClasses__soy1369 += 'tbar-item';
  elementClasses__soy1369 += expand ? ' tbar-item-expand' : '';
  incrementalDom.elementOpenStart('li');
      incrementalDom.attr('class', elementClasses__soy1369);
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'tbar-section');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('span');
          incrementalDom.attr('class', 'component-text text-truncate-inline');
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('span');
            incrementalDom.attr('class', 'text-truncate');
        incrementalDom.elementOpenEnd();
          if (searchValue) {
            /** @desc Says how many results there are for a search */
            var MSG_EXTERNAL_2733824563254516660 = goog.getMsg('{$totalItems}-results-for-{$searchValue}', {'totalItems': '\u00010\u0001', 'searchValue': '\u00011\u0001'});
            var lastIndex_1381 = 0, partRe_1381 = /\x01\d+\x01/g, match_1381;
            do {
              match_1381 = partRe_1381.exec(MSG_EXTERNAL_2733824563254516660) || undefined;
              incrementalDom.text(goog.string.unescapeEntities(MSG_EXTERNAL_2733824563254516660.substring(lastIndex_1381, match_1381 && match_1381.index)));
              lastIndex_1381 = partRe_1381.lastIndex;
              switch (match_1381 && match_1381[0]) {
                case '\u00011\u0001':
                  soyIdom.print(searchValue);
                  break;
                case '\u00010\u0001':
                  soyIdom.print(totalItems);
                  break;
              }
            } while (match_1381);
          } else {
            /** @desc Says how many results there are */
            var MSG_EXTERNAL_4190590659130781466 = goog.getMsg('{$totalItems}-results-for', {'totalItems': '\u00010\u0001'});
            var lastIndex_1393 = 0, partRe_1393 = /\x01\d+\x01/g, match_1393;
            do {
              match_1393 = partRe_1393.exec(MSG_EXTERNAL_4190590659130781466) || undefined;
              incrementalDom.text(goog.string.unescapeEntities(MSG_EXTERNAL_4190590659130781466.substring(lastIndex_1393, match_1393 && match_1393.index)));
              lastIndex_1393 = partRe_1393.lastIndex;
              switch (match_1393 && match_1393[0]) {
                case '\u00010\u0001':
                  soyIdom.print(totalItems);
                  break;
              }
            } while (match_1393);
          }
        incrementalDom.elementClose('span');
      incrementalDom.elementClose('span');
    incrementalDom.elementClose('div');
  incrementalDom.elementClose('li');
}
exports.results = $results;
/**
 * @typedef {{
 *  totalItems: number,
 *  expand: (boolean|null|undefined),
 *  searchValue: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$results.Params;
if (goog.DEBUG) {
  $results.soyTemplateName = 'ClayResultsBar.results';
}

exports.render.params = ["filterLabels","spritemap","totalItems","_handleClearResultsClick","_handleFilterLabelCloseClicked","clearResultsURL","searchValue"];
exports.render.types = {"filterLabels":"list<?>","spritemap":"string","totalItems":"number","_handleClearResultsClick":"any","_handleFilterLabelCloseClicked":"any","clearResultsURL":"string","searchValue":"string"};
exports.clearResults.params = ["_handleClearResultsClick","clearResultsURL"];
exports.clearResults.types = {"_handleClearResultsClick":"any","clearResultsURL":"string"};
exports.filterLabels.params = ["filterLabels","spritemap","_handleFilterLabelCloseClicked"];
exports.filterLabels.types = {"filterLabels":"list<?>","spritemap":"string","_handleFilterLabelCloseClicked":"any"};
exports.results.params = ["totalItems","expand","searchValue"];
exports.results.types = {"totalItems":"number","expand":"bool","searchValue":"string"};
templates = exports;
return exports;

});

class ClayResultsBar extends Component {}
Soy.register(ClayResultsBar, templates);
export { ClayResultsBar, templates };
export default templates;
/* jshint ignore:end */
